// Méthodes de contraception proposées à l'inscription et modifiables depuis le profil.
//
// Les libellés doivent rester alignés au caractère près sur l'enum `ContraceptionType`
// (`app/enums.py`) : c'est la valeur affichée qui est envoyée à l'API, une divergence
// se solde par un 422. La liste vivait en double dans l'onboarding, d'où ce fichier
// commun avant qu'un troisième écran ne crée une troisième copie.

export const CONTRACEPTION_OPTIONS = [
  'Aucune',
  'Sympto-thermique',
  'Pilule combinée',
  'Pilule progestative',
  'Stérilet hormonal',
  'Stérilet en cuivre',
  'Implant contraceptif',
  'Patch contraceptif',
  'Anneau vaginal',
  'Préservatif',
  'Autre',
];
